import { ORDER_TYPE } from 'common/constants/app.constants';
import { alphaNumericValidatorWithSpecialCharacters, numberValidator } from '../../../../common/utils/validator';
import { formElement } from '../summary.constant';
import { getFileType } from 'home/view/manage-feasibility/utils';

export const purchaseOrderExpiryDateKey = 'purchaseOrderExpiryDate';

export const formSchema = {
  purchaseOrderNo: { ...formElement, validator: alphaNumericValidatorWithSpecialCharacters },
  purchaseOrderDate: { ...formElement },
  [purchaseOrderExpiryDateKey]: { ...formElement },
  purchaseOrderTotalCharges: { ...formElement, validator: numberValidator },
  files: { ...formElement }
};

export const ignoreKeys = ['touched', purchaseOrderExpiryDateKey];

export const getDefaultFiles = (uploadedDocs) => {
  if (uploadedDocs && uploadedDocs.PURCHASE_ORDER) {
    const documents = uploadedDocs.PURCHASE_ORDER;
    return Object.keys(documents).reduce((accumulator, documentName) => {
      const splittedValue = (documents[documentName] && documents[documentName].split('purchase_order/')[1]) || '';
      const name = splittedValue || `document${documentName}`;
      const fileType = splittedValue.split('.')[1];
      const type = getFileType(fileType)?.type;

      return accumulator.concat({ name, size: 100, documentName, type });
    }, []);
  }
  return [];
};

export const getDefaultValue = (order) => {
  const {
    purchaseOrder,
    documents,
    companyAddress: { addressLine1 },
    lead: {
      customer: { authorizedSignatory }
    }
  } = order;
  formSchema['purchaseOrderNo'].value = purchaseOrder && purchaseOrder.poNumber ? purchaseOrder.poNumber : purchaseOrder && purchaseOrder.poNumber === 0 ? 0 : '';
  formSchema['purchaseOrderDate'].value = purchaseOrder && purchaseOrder.purchaseOrderDate ? new Date(purchaseOrder.purchaseOrderDate) : '';

  formSchema['purchaseOrderExpiryDate'].value = purchaseOrder && purchaseOrder.purchaseOrderExpiryDate ? new Date(purchaseOrder.purchaseOrderExpiryDate) : '';

  formSchema['purchaseOrderTotalCharges'].value = purchaseOrder && purchaseOrder.poAmount ? purchaseOrder.poAmount : purchaseOrder && purchaseOrder.poAmount === 0 ? 0 : '';
  formSchema['files'] = getDefaultFiles(documents);
  return formSchema;
};
